import { FC } from 'react';
import { DisputeChevron } from './DisputeZoneChip';

interface DisputeValueLinkProps {
  label: string;
  value: string;
  onClick?: () => void;
}

const DisputeValueLink: FC<DisputeValueLinkProps> = ({ label, value, onClick }) => (
  <button
    type="button"
    className="flex w-full items-center gap-1.5 text-left disabled:cursor-default"
    onClick={onClick}
    disabled={!onClick}
    aria-label={`${label} ${value}`}>
    <span className="flex-1 text-px13 text-accentText">{label}</span>
    <span className={`text-sbase font-semibold ${onClick ? 'text-secondary' : 'text-heading'}`}>{value}</span>
    {onClick ? <DisputeChevron /> : null}
  </button>
);

export default DisputeValueLink;
